(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.collection-description__content');
        if (!this.content || this.dataset.init) return;
        this.dataset.init = 'true';

        this.evaluate();

        this.resizeObserver = new ResizeObserver(() => this.evaluate());
        this.resizeObserver.observe(this);

        // Re-check once web fonts load — line metrics change on swap.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.evaluate());
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      evaluate() {
        // Don't fight the reader once they've opened it.
        if (this.hasAttribute('expanded')) return;

        const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
        if (overflowing && !this.button) this.addButton();
        else if (!overflowing && this.button) this.removeButton();
      }

      addButton() {
        if (!this.content.id) {
          this.content.id = 'read-more-' + Math.random().toString(36).slice(2, 9);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'collection-description__toggle';
        button.textContent = this.dataset.more || 'Read more';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', this.content.id);
        button.addEventListener('click', () => this.toggle());
        this.appendChild(button);
        this.button = button;
      }

      removeButton() {
        this.button.remove();
        this.button = null;
      }

      toggle() {
        const expanded = this.toggleAttribute('expanded');
        this.button.textContent = expanded
          ? (this.dataset.less || 'Read less')
          : (this.dataset.more || 'Read more');
        this.button.setAttribute('aria-expanded', String(expanded));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
